import React from 'react';
import './DataTable.css';

const DataTable = ({ 
  data, columns, 
  getRowProps = () => ({}),
  getCellProps = () => ({})
}) => {
  return (
    <div className="table-wrapper">
      <table className="data-table">
        <thead>
          <tr>
            {columns.map((column, index) => (
              <th key={column.key}>{column.label}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data.map((row, index) => (
            <tr key={index} className={getRowProps(row).className}>
              {columns.map((column, index) => (
                <td 
                  key={index}
                  className={getCellProps(row, column).className}
                >
                  {row[column.key]}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default DataTable;
